export default "__VITE_ASSET__D0WemceW__"